import { LineSeparatorLineVariantType } from '../variants';
const buildCommonLineStyles = (FOUNDATIONS) => ({
    border_color: FOUNDATIONS.color_comp_tableslist_lineseparator_regular_border,
    border_width: FOUNDATIONS.size_25,
});
export const getRegularHorizontalStyles = (FOUNDATIONS, FONT) => {
    const commonLineStyles = buildCommonLineStyles(FOUNDATIONS);
    return {
        [LineSeparatorLineVariantType.REGULAR_HORIZONTAL]: {
            topLineStyles: {
                ...commonLineStyles,
                border_top_style: 'solid',
            },
            bottomLineStyles: {
                ...commonLineStyles,
                border_bottom_style: 'solid',
            },
            leftLineStyles: {
                ...commonLineStyles,
                border_left_style: 'solid',
            },
            rightLineStyles: {
                ...commonLineStyles,
                border_right_style: 'solid',
            },
        },
    };
};
//# sourceMappingURL=regularHorizontal.js.map